import React from 'react';
import StrategyMission from '../Components/StrategyComponents/strategyMission/StrategyMission';
// import Enterpren from '../Components/StrategyComponents/Entreprene/Entreprene';
import StrategyFramework from '../Components/StrategyComponents/StrategyFramework/StrategyFramework';


function Strategy() {
  return (
   <>
   <StrategyMission/>
   {/* <Enterpren/> */}
 <StrategyFramework/>
   </>
  );
}

export default Strategy;